import { useAuth } from "@clerk/clerk-expo";
import { useToken } from "@gluestack-style/react";
import myEquipmentImage from "assets/equipment/Equipment.jpg";
import serviceBookingsImage from "assets/equipment/service bookings.jpg";
import BannerImageSlider from "components/general/BannerImageSlider";
import CategoryCard from "components/general/Card/CategoryCard";
import CategoryCardList from "components/general/CategoryCardList";
import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import PageLoader from "components/general/PageLoader";
import ScrollContainer from "components/general/ScrollContainer";
import Seo from "components/general/Seo";
import { PageImageSlider } from "components/page/parts/PageImageSlider";
import { Box, Card, FlatList, FormattedCurrency, H2, H3, H4, H5, HStack, Image, Link, SafeAreaView, View } from "components/ui";
import { BadgeCheck } from "lucide-react-native";
import React from "react";
import { Platform } from "react-native";
import { useGetCategoryQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";

export default function Page() {
	const { data: baseData, isLoading, isFetching, isError, error, currentData } = useGetCategoryQuery();
	const isMobile = useIsMobile();
	const data = baseData?.filter((item) => item.categoryType === "Equipment");
	const resolvedPrimaryLight = useToken("colors", "primarylight");
	const [machineType, setMachineType] = React.useState("");
	const [minPrice, setMinPrice] = React.useState("");
	const [showResults, setShowResults] = React.useState(false);

	const { isSignedIn } = useAuth();

	const [maxPrice, setMaxPrice] = React.useState("");
	if (isLoading) {
		return <PageLoader />;
	}
	const handleBrowse = () => {
		setShowResults(true);
	};
	const cardList = [
		{
			title: "My equipment",
			href: "/equipment/my-equipment",
			imageUrl: myEquipmentImage,
		},
		{
			title: "Service bookings",
			href: "/equipment/service-orders",
			imageUrl: serviceBookingsImage,
		},
		// {
		// 	title: "Hire equipment",
		// 	href: "/equipment/hire-equipment",
		// 	imageUrl: hireEquipmentImage,
		// },
	];

	const equipmentInformationList = [
		{
			title: "Performance & Efficiency",
		},
		{
			title: "Durability & Reliability",
		},
		{
			title: "Support & Maintenance",
		},
	];

	const machineTypeOptions = [
		{ value: "test1", label: "Test 1" },
		{ value: "test2", label: "Test 2" },
		{ value: "test3", label: "Test 3" },
	];
	const minMaxOptions = [
		{ value: "3000", label: <FormattedCurrency amount={3000} /> },
		{ value: "5000", label: <FormattedCurrency amount={5000} /> },
		{ value: "7500", label: <FormattedCurrency amount={7500} /> },
		{ value: "10000", label: <FormattedCurrency amount={10000} /> },
		{ value: "15000", label: <FormattedCurrency amount={15000} /> },
		{ value: "20000", label: <FormattedCurrency amount={20000} /> },
		{ value: "25000", label: <FormattedCurrency amount={25000} /> },
		{ value: "30000", label: <FormattedCurrency amount={30000} /> },
		{ value: "35000", label: <FormattedCurrency amount={35000} /> },
		{ value: "40000", label: <FormattedCurrency amount={40000} /> },
		{ value: "45000", label: <FormattedCurrency amount={45000} /> },
		{
			value: "50000",
			label: (
				<HStack gap={6}>
					<FormattedCurrency amount={50000} />+
				</HStack>
			),
		},
	];
	if (isMobile && Platform.OS !== "web") {
		return (
			<SafeAreaView>
				<FlatList
					ListHeaderComponent={() => (
						<View>
							<H2>Equipment</H2>
						</View>
					)}
					keyExtractor={(item: any) => item.slug}
					data={data ?? []}
					numColumns={2}
					key="_1"
					columnWrapperStyle={{ justifyContent: "space-between" }}
					renderItem={({ item }: any) => (
						<View
							sx={{
								flex: 1 / 2,
							}}
						>
							<CategoryCard category={item} />
						</View>
					)}
				/>
			</SafeAreaView>
		);
	}
	return (
		<ScrollContainer>
			<Seo title="Equipment | Abconet" description="Browse, manage, and maintain equipment records and availability across sites." />
			<Container>
				{/* <PageHeader title="Equipment" /> */}
				{/* <PageImageSlider /> */}
				{isSignedIn ? (
					<PageHeader
						title="Equipment"
						description="Abco Products offers a premium selection of commercial cleaning equipment designed for performance, durability, and efficiency. From vacuum cleaners and scrubbers to sweepers and specialty machines, our equipment helps businesses achieve superior cleaning results with ease. Engineered for reliability and backed by expert support, our solutions cater to various industries, ensuring optimal cleanliness and productivity. Explore our range and find the right equipment to elevate your cleaning standards."
					/>
				) : (
					<BannerImageSlider />
				)}

				{!isSignedIn && (
					<HStack flexDirection={isMobile ? "column" : "row"} py={48} gap={24} paddingHorizontal={isMobile ? 12 : 48}>
						{equipmentInformationList.map((item) => {
							return (
								<HStack key={item.title} sx={{ width: "100%" }} flex={1} gap={16} borderRadius={12} padding={24} bg="$neutral25" alignItems="center" width={"$1/3"}>
									<BadgeCheck width={48} height={48} color={resolvedPrimaryLight} />
									<H4>{item.title}</H4>
								</HStack>
							);
						})}
					</HStack>
				)}
				{/* <Box padding={48} position="relative" zIndex={9} alignItems="center" justifyContent="center" bg="$neutral25" borderRadius={16}>
					<Box
						sx={{
							shadowColor: "#000",
							shadowOffset: {
								width: 0,
								height: 1,
							},
							shadowOpacity: 0.18,
							shadowRadius: 1.0,
							elevation: 1,
						}}
						borderRadius={16}
						w={"$full"}
						bg="$basicwhite"
						maxWidth={780}
						padding={48}
					>
						<Box gap={24} alignItems="center">
							<H3>Shop equipment</H3>
							<TabContainer noPadding isFluid>
								<Tab id="all" key={"all"} title="All">
									<Box position="relative" zIndex={9} width={"$full"} gap={24}>
										<Box position="relative" zIndex={99}>
											<Select placeholder="Select type of machine" options={machineTypeOptions} value={machineType} onChange={setMachineType} />
										</Box>
										<Box position="relative" zIndex={98} flexDirection="row" gap={24}>
											<Box flex={1}>
												<Select placeholder="Price - Min" options={minMaxOptions} value={minPrice} onChange={setMinPrice} />
											</Box>
											<Box flex={1}>
												<Select placeholder="Price - Max" options={minMaxOptions} value={maxPrice} onChange={setMaxPrice} />
											</Box>
										</Box>
										<Box alignItems="center">
											<Button onPress={handleBrowse} sx={{ width: "fit-content" }} variant="primary">
												<Typography sx={{ color: "white" }}>Browse</Typography>
											</Button>
										</Box>
									</Box>
								</Tab>

								<Tab id="new" key={"new"} title="New">
									<Box position="relative" zIndex={9} width={"$full"} gap={24}>
										<Box position="relative" zIndex={99}>
											<Select placeholder="Select type of machine" options={machineTypeOptions} value={machineType} onChange={setMachineType} />
										</Box>
										<Box position="relative" zIndex={98} flexDirection="row" gap={24}>
											<Box flex={1}>
												<Select placeholder="Price - Min" options={minMaxOptions} value={minPrice} onChange={setMinPrice} />
											</Box>
											<Box flex={1}>
												<Select placeholder="Price - Max" options={minMaxOptions} value={maxPrice} onChange={setMaxPrice} />
											</Box>
										</Box>
										<Box alignItems="center">
											<Button onPress={handleBrowse} sx={{ width: "fit-content" }} variant="primary">
												<Typography sx={{ color: "white" }}>Browse</Typography>
											</Button>
										</Box>
									</Box>
								</Tab>
								<Tab id="hire" key={"new"} title="Hire">
									<H4>Important information about equipment</H4>
								</Tab>
								<Tab id="used" key={"new"} title="Used">
									<H4>Important information about equipment</H4>
								</Tab>
							</TabContainer>
						</Box>
					</Box>
				</Box> */}
				{isSignedIn && (
					<Box padding={48} alignItems="center" justifyContent="center">
						<HStack gap={24} w={"$full"}>
							{cardList.map((card: any) => (
								<Link
									pressableStyle={{
										flex: 1,
										shadowColor: "#000",
										shadowOffset: {
											width: 0,
											height: 1,
										},
										shadowOpacity: 0.18,
										shadowRadius: 1.0,
										elevation: 1,
										borderRadius: 16,
									}}
									href={card.href}
									key={card.title}
									onPress={() => console.log(`Navigating to ${card.href}`)}
									component={(hovered: boolean) => {
										return (
											<Card
												style={{
													opacity: hovered ? 0.6 : 1,
													// @ts-ignore
													transition: "opacity 0.3s ease",
													overflow: "hidden",
												}}
											>
												<Box alignItems="center" justifyContent="center" w={"$full"} height={180} bg="$neutral25">
													{/* <Typography.ParagraphSmall>Image here</Typography.ParagraphSmall> */}

													<Image
														source={card.imageUrl}
														style={{ overflow: "hidden", width: "100%", resizeMode: "cover", flex: 1, transform: hovered ? "scale(1.05)" : "scale(1)", transition: "transform 0.3s ease" }}
													/>
												</Box>
												<Box paddingHorizontal={16} paddingBottom={16}>
													<Box paddingHorizontal={20} paddingVertical={12}>
														<H5>{card.title}</H5>
													</Box>
												</Box>
											</Card>
										);
									}}
								/>
							))}
						</HStack>
					</Box>
				)}

				<Box padding={isMobile ? 12 : 48} gap={24} position="relative" zIndex={9} alignItems="center" justifyContent="center" bg="$neutral25" borderRadius={16}>
					<H3>Browse equipment</H3>
					<Box flex={1} w={"$full"}>
						<CategoryCardList list={data} />
					</Box>
				</Box>
			</Container>
		</ScrollContainer>
	);
}
